export const DATA_UPDATED_EVENT = 'compta:data-updated';

export function emitDataUpdated(): void {
  window.dispatchEvent(new Event(DATA_UPDATED_EVENT));
}

export function onDataUpdated(listener: () => void): () => void {
  const handler = () => listener();
  window.addEventListener(DATA_UPDATED_EVENT, handler);
  return () => window.removeEventListener(DATA_UPDATED_EVENT, handler);
}